/* eslint-disable */
import { useMemo } from 'react';
import { computeFacets } from '../utils/devFacetCounts';
import { devMatchesSearch } from './useDevFilters';
import { useDebouncedValue } from './useDebouncedValue';

// useDevFacetCounts — memoised faceted counts for the Developments bar (CLB-079).
// Search is debounced 250 ms like the board's own (Convention #57), so typing
// never recomputes per keystroke. Pure derivation — no query, no RPC.
export function useDevFacetCounts({ devs, devSearch, devFilters, options, inScope }) {
  const search = useDebouncedValue(devSearch || '', 250);
  return useMemo(
    () => computeFacets({ devs, search, filters: devFilters, options, inScope, matchesSearch: devMatchesSearch }),
    [devs, search, devFilters, options, inScope],
  );
}
export default useDevFacetCounts;
